import { cssVar } from '@mfw/common';
import type { Theme } from '@mui/material/styles';

import { tableCellClasses } from '@mui/material/TableCell';
import { tableRowClasses } from '@mui/material/TableRow';

// ----------------------------------------------------------------------

export function table(theme: Theme) {
  return {
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: cssVar.background.neutral,
          color: cssVar.text.secondary,
          fontSize: 14,
          fontWeight: theme.typography.fontWeightSemiBold,
        },
        paddingCheckbox: {
          paddingLeft: theme.spacing(1),
        },
        root: {
          borderBottomStyle: 'dashed',
        },
        stickyHeader: {
          backgroundColor: cssVar.background.paper,
          backgroundImage: `linear-gradient(to bottom, ${cssVar.background.neutral} 0%, ${cssVar.background.neutral} 100%)`,
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          position: 'relative',
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        actions: {
          marginRight: 8,
        },
        root: {
          width: '100%',
        },
        select: {
          '&:focus': {
            borderRadius: theme.shape.borderRadius,
          },
          paddingLeft: 8,
        },
        selectIcon: {
          height: 16,
          right: 4,
          top: 'calc(50% - 8px)',
          width: 16,
        },
        toolbar: {
          height: 64,
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:last-of-type': {
            [`& .${tableCellClasses.root}`]: {
              borderColor: 'transparent',
            },
          },
          [`&.${tableRowClasses.selected}`]: {
            '&:hover': {
              backgroundColor: `color-mix(in srgb, ${cssVar.primary.dark} 8%, transparent)`,
            },
            backgroundColor: `color-mix(in srgb, ${cssVar.primary.dark} 4%, transparent)`,
          },
        },
      },
    },
  };
}
